module.exports = __webpack_public_path__ + "static/AXAColHome-8a47ffe3742305a25339e919d7a70203.png";